export const optimizeImage = (
  url: string,
  width?: number,
  quality: number = 80,
) => {
  if (!url || !url.startsWith("http")) return url;
  if (url.includes("wsrv.nl") || url.endsWith(".svg")) return url;

  const params = new URLSearchParams();
  params.append("url", url);
  params.append("output", "webp");
  params.append("q", quality.toString());
  if (width) params.append("w", width.toString());

  return `https://wsrv.nl/?${params.toString()}`;
};
